module.exports = __webpack_public_path__ + "static/media/studyc.46e71bf9.png";